import Utility from './../Utility';

export default class IntentUsedIn {
    
    static getIntentUsedIn(intent, serialized){
        const {components, globalIntents, compoundIntents, functions} = serialized;
        var intentUsedIn = {
            intentsUsedInGlobalIntents: IntentUsedIn.getIntentUsedInGlobalIntents(intent, components, globalIntents),
            intentsUsedInCompoundIntents: IntentUsedIn.getIntentUsedInCompoundIntents(intent, compoundIntents),
            intentsUsedInFlowLinks:  IntentUsedIn.getIntentUsedInInFlowLinks(intent, components),
            intentsUsedInDtmfNodes: IntentUsedIn.getIntentUsedInDtmfNodes(intent, components),
            intentsUsedInInputNodes: IntentUsedIn.getIntentUsedInInputNodes(intent, components),
            intentsUsedInCustomNodes: IntentUsedIn.getIntentUsedInCustomNodes(intent, components),
            intentsUsedInFunctions: IntentUsedIn.getIntentUsedInFunctions(intent, functions)
        }

        return intentUsedIn;
    }
    
    static getIntentUsedInGlobalIntents(intent, components, globalIntents){
        const intentUsedInGlobalIntents = [];
        if(intent.name!==""){
            globalIntents.forEach(gi => {
                if(gi.intent === intent.id){
                    const mod = components.modules.find(mod => mod.id === gi.module);
                    intentUsedInGlobalIntents.push({
                    module: mod
                    });
                }
            })
        }
       
        return intentUsedInGlobalIntents;
    }

    static getIntentUsedInCompoundIntents(intent, compoundIntents){
        const intentsUsedInCompoundIntents = [];
        compoundIntents.forEach(ci => {
            if(ci.fromIntent1 === intent.id || ci.fromIntent2 === intent.id || ci.toIntent === intent.id){
                intentsUsedInCompoundIntents.push({
                    compoundIntent: ci
                });
            }
        });
        return intentsUsedInCompoundIntents;
    }

    static getIntentUsedInInFlowLinks(intent, components){
        const {modules} = components;
        const intentsUsedInFlowLinks = [];
        if(intent.name!==""){
            modules.forEach(mod => {
                const flow = mod.versions[1].flow;
                const {links} = flow;
                const intentFoundInCondition = links.filter(l => l.props.config.condition.filter(c => c[0].indexOf('"' + intent.name) !== -1 || c[0].indexOf("'" + intent.name) !== -1).length > 0)
                if (intentFoundInCondition.length > 0){
                    intentsUsedInFlowLinks.push({
                        module: mod.id
                    });
                }
            });
        }
        return intentsUsedInFlowLinks;
    }

    static getIntentUsedInDtmfNodes(intent, components){
        const dtmfObjects = components.objects.filter(obj => obj._class === "DtmfNodeModel");
        const usedInDtmf = [];
        dtmfObjects.forEach(dtmf => {
                dtmf.props.config.selections = dtmf.props.config.selections || []
                const intentIsFoundInDtmf = dtmf.props.config.selections.findIndex(sel => sel.value === intent.id) !== -1;
                if (intentIsFoundInDtmf){
                    usedInDtmf.push({
                        node: dtmf
                    })
                }    
        });
        
        return usedInDtmf;
    }

    static getIntentUsedInInputNodes(intent, components){
        const inputObjects = components.objects.filter(obj => obj._class === "InputNodeModel");
        const usedInInputNodes = [];
        inputObjects.forEach(input => {
                input.props.config.localIntents = input.props.config.localIntents || [];
                const isIntentFoundInInputNode = input.props.config.localIntents.indexOf(intent.id) !== -1;
                const isIntentFoundInExpectedIntent = input.props.config.expectedIntent && input.props.config.expectedIntent === intent.id;
                const isIntentFoundInImpliedIntent = input.props.config.impliedIntent && input.props.config.impliedIntent === intent.id;
                const isIntentFoundInDtmfIntent = input.props.config.dtmfIntent && input.props.config.dtmfIntent === intent.id;
                if (isIntentFoundInInputNode || isIntentFoundInExpectedIntent || isIntentFoundInImpliedIntent || isIntentFoundInDtmfIntent){
                    usedInInputNodes.push({
                        node: input
                    })
                }    
            });
       
        return usedInInputNodes;
    }

    static getIntentUsedInCustomNodes(intent, components){
        const customNodes = components.objects.filter(obj => obj._class === "CustomNodeModel");
        const usedInCustomNodes = [];
        if(intent.name!==""){
            customNodes.forEach(custom => {
                if(custom.props.config.function && custom.props.config.function.script){
                    if (JSON.stringify(custom.props.config.function.script).includes(intent.name)){
                        usedInCustomNodes.push({
                        node: custom
                        })
                    }
                }
            }); 
        }
        return usedInCustomNodes;
    }

    static getIntentUsedInFunctions(intent, functions){
        const usedInFunctions = [];
        if(intent.name!==""){
            if (functions){
                functions.forEach(fun => {
                    if (JSON.stringify(fun.script).includes(intent.name) || JSON.stringify(fun.script).includes(intent.name)){
                        usedInFunctions.push({
                        function: fun
                        })
                    }
                 });
            }
        }
        return usedInFunctions;
    }

}